import styled from 'styled-components'

export const Container = styled.div`
  width: 3.3125rem;

  overflow: hidden;
  box-shadow: 0px 1.85px 18px rgba(0, 0, 0, 0.15);
  border-radius: 10px;

  position: fixed;
  right: 0;
  bottom: 50vh;

  margin-bottom: 1rem;

  span {
    font-size: 5px;
  }

  .sliderContainer {
    position: relative;

    height: 8rem;
  }

  .sliderWrapper {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;

    height: fit-content;

    background-color: ${({ theme }) => `rgb(${theme.background.low})`};
    border-radius: 0.5rem;
    padding: 0px 5px;

    input {
      transform: rotate(270deg);
    }
  }

  .rangeValue {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
